import { CLOSE_VIEW_PROPOSAL } from '../constants';

export const closeViewProposal = () => {
  return (dispatch, getState) => {
    dispatch({ type: CLOSE_VIEW_PROPOSAL });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/viewProposalActions.js